/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
import styled from '@essex/styled-components'

export const DataDisplay = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`
